import { Groq } from 'groq-sdk';

const DEFAULTS = {
  max_tokens: 1024,
  temperature: 0.6,
  top_p: 0.9,
  presence_penalty: 0.3,
  frequency_penalty: 0.2,
};

export async function rewriteTextLLM(text) {
  try {
    const settings = JSON.parse(localStorage.getItem('groqSettings') || '{}');

    // اولویت: تنظیمات کاربر -> مقادیر پیش‌فرض
    const apiKey = settings.apiKey || process.env.REACT_APP_GROQ_API_KEY;
    const model = settings.model || 'meta-llama/llama-4-maverick-17b-128e-instruct';
    const max_tokens = parseInt(settings.maxLength || DEFAULTS.max_tokens, 10);
    const temperature = parseFloat(settings.temperature || DEFAULTS.temperature);
    const top_p = parseFloat(settings.topP || DEFAULTS.top_p);
    const presence_penalty = parseFloat(settings.presencePenalty || DEFAULTS.presence_penalty);
    const frequency_penalty = parseFloat(settings.frequencyPenalty || DEFAULTS.frequency_penalty);

    if (!apiKey) {
      throw new Error('No Groq API Key provided.');
    }

    const groq = new Groq({ apiKey, dangerouslyAllowBrowser: true });

    const chatCompletion = await groq.chat.completions.create({
      messages: [
        {
          role: 'system',
          content: systemPrompt(),
        },
        {
          role: 'user',
          content: text,
        },
      ],
      model,
      temperature,
      top_p,
      presence_penalty,
      frequency_penalty,
      max_tokens,
    });

    return chatCompletion.choices[0].message.content;
  } catch (err) {
    console.error('Rewrite Error:', err);
    return '[خطا در بازنویسی متن]';
  }
}

// پیام system جدید
function systemPrompt() {
  return `You are a rewriting assistant. Rewrite user-provided English texts clearly, fluently, and naturally.
You may enhance coherence, adjust phrasing slightly for friendliness, and refine expressions to sound more like a personal advisor.
Avoid adding significant new information or drastically changing the meaning.
Do not apply formatting such as bold, italics, or markdown.
Only return the rewritten version directly without commentary.`;
}
